import { AppStoreBadge } from '../StoreButtons';

const Testimonials = () => (
  <section className="py-16 bg-[#1E2328]" data-testid="testimonials-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          What Guides & Experienced Anglers Say
        </h2>
        <p className="text-lg text-slate-400">
          Real anglers, real waters, real results
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-[#0F1419] rounded-2xl p-8 shadow-lg border border-white/10">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-16 h-16 bg-[#137dc5] rounded-full flex items-center justify-center text-white font-bold text-xl flex-shrink-0">
              MR
            </div>
            <div>
              <h3 className="text-lg font-bold text-white">Mike Richards</h3>
              <p className="text-slate-400 text-sm">Certified Fly Fishing Guide • Bow River, AB</p>
              <p className="text-slate-500 text-xs mt-1">15+ years guiding experience</p>
            </div>
          </div>
          <p className="text-slate-300 leading-relaxed mb-4">
            "I tested FlyFinder on the Bow River in late September. Water temp was 13°C, overcast skies. The app recommended #18 BWO emergers—exactly what I would have chosen based on the conditions. What impressed me was the <strong className="text-white">explanation of why</strong>: 'BWO emergence peaks at 12-15°C, overcast triggers surface activity.' That's the kind of knowledge that takes years to learn."
          </p>
          <div className="flex items-center gap-2 text-[#3aa0e0] text-sm font-semibold">
            <span>✓</span>
            <span>Verified Guide • September 2024</span>
          </div>
        </div>

        <div className="bg-[#0F1419] rounded-2xl p-8 shadow-lg border border-white/10">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-16 h-16 bg-[#137dc5] rounded-full flex items-center justify-center text-white font-bold text-xl flex-shrink-0">
              JL
            </div>
            <div>
              <h3 className="text-lg font-bold text-white">Jennifer Lawson</h3>
              <p className="text-slate-400 text-sm">Fly Fishing Writer • Montana & Idaho</p>
              <p className="text-slate-500 text-xs mt-1">Contributor to Western Fly Fisher Magazine</p>
            </div>
          </div>
          <p className="text-slate-300 leading-relaxed mb-4">
            "I used FlyFinder on the Madison River during the PMD hatch in July. Water temp: 16°C, morning calm. It recommended #16 PMD Sparkle Dun. The outcome? <strong className="text-white">Three 18-inch rainbows in the first hour.</strong> What separates this from generic 'hatch apps' is the regional specificity—it knows Montana PMDs emerge different than Pennsylvania streams."
          </p>
          <div className="flex items-center gap-2 text-[#3aa0e0] text-sm font-semibold">
            <span>✓</span>
            <span>Verified Writer • July 2024</span>
          </div>
        </div>

        <div className="bg-[#0F1419] rounded-2xl p-8 shadow-lg border border-white/10">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-16 h-16 bg-[#137dc5] rounded-full flex items-center justify-center text-white font-bold text-xl flex-shrink-0">
              TC
            </div>
            <div>
              <h3 className="text-lg font-bold text-white">Tom Chen</h3>
              <p className="text-slate-400 text-sm">Tournament Angler • Pacific Northwest</p>
              <p className="text-slate-500 text-xs mt-1">3x Regional Fly Fishing Champion</p>
            </div>
          </div>
          <p className="text-slate-300 leading-relaxed mb-4">
            "Tested FlyFinder on an unfamiliar tailwater in Colorado. I had zero local knowledge. Water temp reading: 11°C, light drizzle. App said midge clusters, #20-22 Griffith's Gnat. <strong className="text-white">Caught fish within 20 minutes.</strong> The temperature-trigger data is legit—this isn't guessing, it's documented emergence windows."
          </p>
          <div className="flex items-center gap-2 text-[#3aa0e0] text-sm font-semibold">
            <span>✓</span>
            <span>Verified Competitor • October 2024</span>
          </div>
        </div>

        <div className="bg-gradient-to-br from-cyan-600 to-cyan-700 text-white rounded-2xl p-8 shadow-lg">
          <div className="mb-6">
            <h3 className="text-xl font-bold mb-2">Now Available on the Apple App Store</h3>
            <p className="text-cyan-100 text-sm">
              Join the community of experienced anglers fishing smarter with FlyFinder on their home waters
            </p>
          </div>
          <p className="text-white leading-relaxed mb-6 italic">
            "The best tools are built by users. If you know the difference between a Baetis bicaudatus and a tricaudatus, you'll feel right at home."
          </p>
          <AppStoreBadge className="h-12" />
        </div>
      </div>
    </div>
  </section>
);

export default Testimonials;
